import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";

import { resetBankState } from "../features/merchant/bankSlice";
import { resetBizState } from "../features/merchant/biz";
import { resetAllDocuments } from "../features/merchant/doc";
import { resetState as resetMerchantState } from "../features/merchant/MerchantSlice/MerchantSlice";
import { resetState as resetPaymentState } from "../features/merchant/MerchantSlice/PaymentTrackingSlice";
import { resetRepState } from "../features/merchant/rep";
import { resetRegistrationBankState } from "../features/registration/bankSlice";
import { resetRegistrationBizState } from "../features/registration/bizSlice";
import { resetAllRegistrationDocuments } from "../features/registration/docSlice";
import { resetRegistrationRepState } from "../features/registration/repSlice";

/**
 * All Redux reset actions for the admin app.
 * Used by performLogoutCleanup to reset all state slices on logout.
 */
export const adminResetActions: Array<() => { type: string }> = [
  resetAuthState,
  resetRegistrationBizState,
  resetRegistrationRepState,
  resetRegistrationBankState,
  resetAllRegistrationDocuments,
  resetBizState,
  resetBankState,
  resetRepState,
  resetAllDocuments,
  resetMerchantState,
  resetPaymentState,
];
